import router from '../router'

export function checkIsWexin()
{
  // var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
  // return ua.indexOf("micromessenger") != -1; //判断是否

  var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
  if (/(micromessenger)/i.test(ua)) 
  { 
    // //是否电脑微信或者微信开发者工具
    // if(/(WindowsWechat)/i.test(ua) || /(wechatdevtools)/i.test(ua))
    // {
      
    // }
    // else
    // {
    //   return true;
    // }

    return true;
  } 
  else 
  {
  }

  return false;
}


export function checkIsIOS() 
{
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function checkIsMobile()
{
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}

export function checkIsMiniApp()
{
  const isMiniProgram = /MicroMessenger/.test(navigator.userAgent);
  return isMiniProgram;
}

export function toHelp(id)
{
  // if(checkIsMiniApp())
  // {
  //   wx.miniProgram.navigateTo({url: '/subPage/userHelp/userHelpDetail?navLeft=true&scene=53'})
  // }
  // else
  // {
  //   router.push({
  //     path: "/userHelpDetail",
  //     query: {
  //       id: id
  //     }
  //   });
  // }
  const url =  window.location.origin + '/home/userHelpDetail?id=' + id;
  window.open(url, '_blank');
}

export function toLogin()
{
  if(checkIsMiniApp())
  {
   
  }
  else
  {
    router.push({
      path: "/",
      query: {
      }
    });
  }
}


export function formatDate(val, cn) {
  if (!val) return "";
  const date = new Date(val);
  return (
    date.getFullYear() +
    (cn ? "年" : "/") +
    pad0(date.getMonth() + 1) +
    (cn ? "月" : "/") +
    pad0(date.getDate()) +
    (cn ? "日" : "")
  );
}

function pad0(n) {
  return n < 10 ? "0" + n : n;
}

export function priceFormat(num,fixedNum) 
{
  if(!fixedNum)
  {
    fixedNum = 2;
  }
  
  // 将数字转换为字符串
  num = num.toFixed(fixedNum);
  // 使用正则表达式添加千分位
  num = num.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  return num;
}